import CircularProgress from '@mui/material/CircularProgress'
import { Box } from '@mui/material'

function LoadComponent() {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <CircularProgress aria-label="Loading…" />
    </Box>
  )
}

export default LoadComponent
